import { render, staticRenderFns } from "./UcSuggestProjectOption.yaml?vue&type=template&id=36dbe94c&component"
import script from "./UcSuggestProjectOption.yaml?vue&type=script&lang=ts&component"
export * from "./UcSuggestProjectOption.yaml?vue&type=script&lang=ts&component"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports